import { object, array, mixed } from '@calendly/form/validation'
import { I18n } from '@calendly/i18n'

export const validationSchema = () => object({
  mappings: array()
    .compact(({ attrValue, groupId }) => !attrValue && !groupId)
    .of(
      mixed().test({
        test: ({ attrValue, groupId }, { path, createError }) => {
          if (attrValue && !groupId) {
            return createError({
              path: `${path}.groupId`,
              message: I18n.t('publisher.organization_settings.user_provisioning.groups.errors.enter_group_name')
            })
          }

          if (!attrValue && groupId) {
            return createError({
              path: `${path}.attrValue`,
              message: I18n.t('publisher.organization_settings.user_provisioning.groups.errors.enter_value')
            })
          }

          return true
        }
      })
        .test((mappingItem, { parent: mappings, path, createError }) => {
          const { attrValue, groupId, id } = mappingItem
          const duplicate = mappings
            .filter((mapping) => !mapping.isBeingDeleted)
            .find(
              (mapping) => mapping.id !== id && mapping.attrValue === attrValue && mapping.groupId === groupId
            )

          if (duplicate) {
            return createError({
              path,
              message: I18n.t('publisher.organization_settings.user_provisioning.groups.errors.duplicate_entry')
            })
          }

          return true
        })
    )
})
